import React, { useState } from 'react'
import I18n from 'i18n'
import ComplianceChart from './ComplianceChart'
import { useResearchDashboardMetricsQuery } from '../../../../backend/Queries'

export default function EcgComplianceChart (): React.ReactElement {
  type EcgPeriod = 'weekly' | 'monthly'
  const [period, setPeriod] = useState<EcgPeriod>('weekly')
  const [offset, setOffset] = useState(0)
  const { data, isLoading } = useResearchDashboardMetricsQuery(period, offset)

  const changePeriod = (newPeriod: EcgPeriod): void => {
    setPeriod(newPeriod)
    setOffset(0)
  }

  const periodToggle = (
    <div className='rd-period-toggle'>
      <button
        className={`rd-toggle-btn ${period === 'weekly' ? 'active' : ''}`}
        onClick={() => changePeriod('weekly')}
      >
        {I18n.t('components.dashboards.research_dashboard.charts.toggle_weekly')}
      </button>
      <button
        className={`rd-toggle-btn ${period === 'monthly' ? 'active' : ''}`}
        onClick={() => changePeriod('monthly')}
      >
        {I18n.t('components.dashboards.research_dashboard.charts.toggle_monthly')}
      </button>
    </div>
  )

  return (
    <ComplianceChart
      title={I18n.t(`components.dashboards.research_dashboard.charts.compliance_${period}_ecg`)}
      data={data?.ecg}
      color='#011258'
      isLoading={isLoading}
      offset={offset}
      onOffsetChange={setOffset}
      periodToggle={periodToggle}
      currentWeekLabel={offset === 0 ? data?.ecg?.history?.[data.ecg.history.length - 1]?.label : undefined}
    />
  )
}
